import { render } from "./LabQuestions.vue?vue&type=template&id=48a6ef75"
import script from "./LabQuestions.vue?vue&type=script&lang=js"
export * from "./LabQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__